<script lang="ts" module>
  import { diffWords } from 'diff';

  import type { AISuggestion } from '@/teoCore/text/AIHandler';
  import BaseBtn from '@/ui/base/BaseBtn.svelte';
  import Icon from '@/ui/base/icon/Icon.svelte';

  export interface AISuggestionProps {
    aiSuggestions: AISuggestion[];
    finalStateMessage?: string;
    onInsertClick?: (aiSuggestions?: AISuggestion) => void;
    showSuggestion: number;
  }
</script>

<script lang="ts">
  let {
    aiSuggestions: ai = $bindable(),
    showSuggestion: show = $bindable(),
    ...props
  }: AISuggestionProps = $props();

  // Calculates the index of the shown suggsestion
  $effect(() => {
    show = Math.max(Math.min(show, ai.length - 1), 0);
  });

  let showText = $derived.by(() => {
    if (ai.length === 0) {
      return props.finalStateMessage ?? '';
    }
    if (ai[show]?.error) {
      return ai[show]?.replacement;
    }
    return generateDiff(ai[show]?.context.text ?? '', ai[show]?.replacement ?? '');
  });

  function generateDiff(oldStr: string, newStr: string): string {
    let html = '';
    let diff = diffWords(oldStr, newStr);
    diff.forEach((part) => {
      let p: string;
      if (part.added)
        p = '<ins class="decoration-marker-change underline-offset-2">' + part.value + '</ins>';
      else if (part.removed)
        p = '<del class="hidden decoration-marker-change">' + part.value + '</del>';
      else p = part.value;
      html += p;
    });
    return html;
  }
</script>

<div class="relative rounded-sm bg-sec py-3 pl-3 pr-6 hover:bg-sec-H">
  <div class="font-sans text-sm font-normal text-c-base">
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html showText}
  </div>
  {#if ai.length > 1}
    <BaseBtn
      class="absolute right-1 top-1"
      onclick={() => {
        ai.splice(show, 1);
      }}
    >
      <Icon icon="Close" class="size-4 text-c-light"></Icon>
    </BaseBtn>
  {/if}
  {#if ai.length > 0}
    <BaseBtn
      class="absolute bottom-1 right-1"
      onclick={() => {
        props.onInsertClick?.(ai[show]);
      }}
    >
      {#if !ai[show]?.error}
        <Icon icon="Transfer" class="size-4 text-c-link"></Icon>
      {/if}
    </BaseBtn>
  {/if}
</div>
